<template>
    <el-dialog :visible="visible" ref="DetailDialog" :modal-append-to-body="false" class="variable-statment-detail-dialog ah-detail-dialog gray-bg" top="5vh" append-to-body @close="onDialogClose">
        <template slot="title">
            <el-row>
                <el-col :span="16">
                    <span style="padding-right: 5px; position: relative">
                        <template v-if="form.type">
                            <span class="ah-status reject" v-if="form.flg === -1">
                                {{ getTypeNameByNum(form.type) }}
                            </span>
                            <span class="ah-status done" v-else>
                                {{ getTypeNameByNum(form.type) }}
                            </span>
                        </template>
                        <template v-else>
                            <span class="ah-status reject" v-if="form.flg === -1"> 支出 </span>
                            <span class="ah-status done" v-else>收入</span>
                        </template>
                    </span>
                    <span>
                        財務收支 <span class="sno"># {{ this.form.moo }}</span>
                    </span>
                </el-col>
            </el-row>
        </template>

        <div class="detail-card">
            <div class="detail-block">
                <div style="font-size: 15pt; font-weight: bold; margin-bottom: 25px">
                    {{ form.tpc }}
                </div>
            </div>
            <table class="ah-basic-data-table" cellpadding="0" cellspacing="0" style="margin-bottom: 30px">
                <tr>
                    <th>金額：</th>
                    <td>
                        <span style="font-size: 15pt; font-weight: bold; margin-right: 5px">
                            <Money :v="form.amt" :precision="form.cny === 'TWD' ? null : 4"  />
                        </span>
                        <span>
                            {{ form.cny }}
                        </span>
                    </td>
                </tr>
                <tr>
                    <th>{{ form.flg === -1 ? "繳費" : "收款" }}日期：</th>
                    <td>
                        <span style="margin-right: 5px">{{ form.paY_DAT | dateFormater("YYYY-MM-dd") }} </span>
                        <span v-if="form.flg === -1">
                            <el-tag type="success" size="small" v-if="+new Date() > form.paY_DAT"> <i class="el-icon-check"></i> 已繳 </el-tag>
                            <el-tag type="warning" size="small" v-else> <i class="el-icon-time"></i> 待繳 </el-tag>
                        </span>
                        <span v-else>
                            <el-tag type="success" size="small" v-if="+new Date() > form.paY_DAT"> <i class="el-icon-check"></i> 已收 </el-tag>
                            <el-tag type="warning" size="small" v-else> <i class="el-icon-time"></i> 待收 </el-tag>
                        </span>
                    </td>
                </tr>
                <tr v-if="form.bnK_SNO > 0">
                    <th>銀行帳戶：</th>
                    <td>
                        <div class="bank-account-tpc">
                            {{ getBankName(form.bnK_SNO) }}
                        </div>
                    </td>
                </tr>
                <tr v-else>
                    <th>付款方式：</th>
                    <td>零用現金付款</td>
                </tr>
                <tr>
                    <th>{{ form.flg === -1 ? "支出" : "收入" }}項目：</th>
                    <td>
                        <span v-if="form.sno">{{ getItemName(form.iteM_SNO) }}</span>
                    </td>
                </tr>
                <tr v-if="form.froM_UNT === 'REM_FEE'">
                    <th>匯款來源：</th>
                    <td>
                        <div v-for="source in form.remittanceSources" :key="source.systemNo">
                            <el-button v-if="source.typ === 'payment'" type="text" style="padding: 0" @click="showPayment(source.sno)"> {{ source.systemNo }} </el-button>
                            <el-button v-else-if="source.typ === 'invoice'" type="text" style="padding: 0" @click="showInvoice(source.sno)"> {{ source.systemNo }} </el-button>
                        </div>
                    </td>
                </tr>
                <tr v-if="form.createdByUser">
                    <th>備註：</th>
                    <td>
                        <div style="margin: 2px 0; white-space: pre-wrap">{{ form.mem ? form.mem : "(無)" }}</div>
                    </td>
                </tr>
                <tr v-if="form.froM_UNT === 'TRANSFER'">
                    <th>備註：</th>
                    <td>
                        <div style="margin: 2px 0; white-space: pre-wrap">
                            <span>同{{ form.transferSystemNo }}</span
                            ><br /><span>{{ form.transferNote ? form.transferNote : "(無)" }}</span>
                        </div>
                    </td>
                </tr>
            </table>
        </div>

        <div v-if="form.createdByUser" class="detail-card">
            <FilesView ref="FilesView" :form="form" :disabled="form.vocherStatus === 1" @change="onChangeFiles" @reload="refresh" />
        </div>

        <TransferTargetInfoView
            v-if="form.vdR_BNK_ACC"
            :bnk-acc="form.vdR_BNK_ACC"
            :bnk-boo="form.vdR_BNK_BOO"
            :bnk-doo="form.vdR_BNK_DOO"
            :bnk-tcp="form.vdR_BNK_TPC"
            :bank-name="form.bankName"
            :flg="form.flg"
        />

        <AccountingInfoBlock
            v-if="form.createdByUser || form.froM_UNT === 'REM_FEE'"
            :sno="form.sno"
            :qty="form.voU_COUNT"
            :status="form.vocherStatus"
            :queryType="accountingInfoQueryType"
            :voucher-status-updater="form.voucherStatusUpdateName"
            :voucher-status-update-date="form.voucherStatusUpdateDate"
            @refresh="() => reload()"
        />

        <el-alert :closable="false" v-if="!form.createdByUser" class="alert-block">此為系統自動產生 </el-alert>

        <div class="detail-row footer">
            <el-row>
                <el-col :sm="14" style="font-size: 9pt; color: #666">
                    <div>資料建立：{{ form.crT_USR }} ({{ form.crT_DAT | dateFormater("YYYY-MM-dd") }})</div>
                    <div v-if="form.upD_USR">最後編輯：{{ form.upD_USR }} ({{ form.upD_DAT | dateFormater("YYYY-MM-dd") }})</div>
                </el-col>
                <el-col :sm="10">
                    <div v-if="form.createdByUser" style="text-align: right">
                        <template v-if="form.vocherStatus === 0">
                            <el-button v-if="form.createdByUser && isAuth('E01')" type="primary" plain size="small" @click="$emit('edit', { visible: true, sno: form.sno })">修改</el-button>
                            <el-button v-if="form.createdByUser && isAuth('E01')" plain size="small" @click="handleDeleteBtnClick">刪除</el-button>
                        </template>
                        <template v-if="form.vocherStatus === 1">
                            <el-tooltip class="item" effect="light" content="此單已完成財會檢核，無法編輯。" placement="top">
                                <el-button disabled>修改</el-button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="light" content="此單已完成財會檢核，無法編輯。" placement="top">
                                <el-button disabled>刪除</el-button>
                            </el-tooltip>
                        </template>
                    </div>
                    <div v-else style="text-align: right">
                        <el-button v-if="form.payoutNo !== null" size="small" @click="showPayment(form.payoutSno)"> 檢視來源請款單 {{ form.payoutNo }} </el-button>
                        <el-button v-if="form.transferSno !== null" size="small" @click="showTransfer(form.transferSno)"> 檢視來源存款帳戶互轉 {{ form.transferSystemNo }} </el-button>
                        <el-button v-if="form.drawdownSno !== null" size="small" @click="showDrawdown(form.drawdownSno)"> 檢視來源動播 {{ form.drawdownSystemNo }}</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <payment-detail-dialog @close="onPaymentDialogClose" :sno="paymentDialog.sno" :visible="paymentDialog.visible"> </payment-detail-dialog>
        <BankTransferDetailDialog :visible="bankTransferDetailDialog.visible" :sno="bankTransferDetailDialog.sno" @close="onBankTransferDetailDialogClose" />
        <DrawdownDetailDialog ref="drawDetailDialog" :visible="drawDetailDialog.visible" :sno="drawDetailDialog.sno" view-mode @close="onDrawDetailDialogClose" />
        <InvoiceDetailDialog :visible="invoiceDetailDialog.visible" :sno="invoiceDetailDialog.sno" @close="onInvoiceDetailDialogClose" />
    </el-dialog>
</template>
<script>
import { statementTypes } from '@/assets/commonData/options';
import FilesView from '@/components/dashboard/Finance/VariableStatement/FilesView.vue';
import TransferTargetInfoView from '@/components/dashboard/Finance/VariableStatement/TransferTargetInfoView.vue';
import BankTransferDetailDialog from '@/components/dashboard/Finance/VariableStatement/BankTransferDetailDialog.vue';
import DrawdownDetailDialog from '@/components/dashboard/Finance/LoanManagement/DrawDetailDialog.vue';
import PaymentDetailDialog from '../../Payment/PaymentDetailDialog.vue';

export default {
    name: 'VariableStatementDetailDialog',
    components: {
        PaymentDetailDialog,
        AccountingInfoBlock: () => import('@/components/ui/AccountingInfoBlock.vue'),
        FilesView,
        TransferTargetInfoView,
        BankTransferDetailDialog,
        DrawdownDetailDialog,
        InvoiceDetailDialog: () => import('@/components/dashboard/Invoice/InvoiceDetailDialog.vue'),
    },
    props: ['visible', 'sno'],
    data() {
        return {
            form: {},
            bankAccountList: [],
            statementList: [],

            paymentDialog: { sno: null, visible: false },
            bankTransferDetailDialog: { visible: false, sno: null },
            drawDetailDialog: { visible: false, sno: null },
            invoiceDetailDialog: { visible: false, sno: null },
        };
    },
    computed: {
        inputObject() {
            return {
                year: this.$route.params.year,
                month: this.$route.params.month,
                items: this.form.items,
            };
        },
        accountingInfoQueryType() {
            switch (this.form.type) {
            case 2:
                return 5;
            case 5:
                return 4;
            case 6:
                return 6;
            default:
                return 5;
            }
        },
    },
    created() {
        this.fetchBankList();
    },
    watch: {
        sno(newSno) {
            if (newSno) this.fetchDetailData(newSno);
            else this.emptyData();
        },
    },
    methods: {
        showPayment(sno) {
            this.paymentDialog.sno = sno;
            this.paymentDialog.visible = true;
        },
        showTransfer(sno) {
            this.bankTransferDetailDialog.sno = sno;
            this.bankTransferDetailDialog.visible = true;
        },
        showDrawdown(sno) {
            this.drawDetailDialog.visible = true;
            this.drawDetailDialog.sno = sno;
            this.$nextTick(() => {
                this.$refs.drawDetailDialog.fetchData();
            });
        },
        showInvoice(sno) {
            this.invoiceDetailDialog.sno = sno;
            this.invoiceDetailDialog.visible = true;
        },
        onPaymentDialogClose() {
            this.paymentDialog.visible = false;
            this.paymentDialog.sno = null;
        },
        onInvoiceDetailDialogClose() {
            this.invoiceDetailDialog.visible = false;
            this.invoiceDetailDialog.sno = null;
        },
        onBankTransferDetailDialogClose() {
            this.bankTransferDetailDialog.visible = false;
            this.bankTransferDetailDialog.sno = null;
        },
        onDrawDetailDialogClose() {
            this.drawDetailDialog.visible = false;
            this.drawDetailDialog.sno = null;
        },
        getTypeNameByNum(type) {
            if (type === 1) return '營業其他收入';
            if (type === 2) return '營業其他支出';
            if (type === 5) return '財務資產收入';
            if (type === 6) return '財務資產支出';
            return null;
        },
        handleDeleteBtnClick() {
            const dirTxt = this.form.flg === -1 ? '支出' : '收入';

            this.$confirm(`確定要讓刪除該筆財務${dirTxt}？`, {
                confirmButtonText: '確定刪除',
                cancelButtonText: '取消',
            }).then(() => {
                this.submitDelete();
            });
        },
        submitDelete() {
            this.$api({
                url: '/VariableStatementSettingPage/DeleteStatementForm',
                data: { sno: this.form.sno },
                method: 'POST',
            }).then(() => {
                this.$emit('close', true);
            });
        },
        emptyData() {
            this.form = {};
        },
        onDialogClose() {
            this.$emit('close', false);
        },
        async fetchDetailData(sno) {
            const loadingTarget = this.$refs.DetailDialog.$el.querySelector('.el-dialog');
            const loading = this.$loading({
                lock: true,
                text: '載入中',
                spinner: 'el-icon-loading',
                target: loadingTarget,
            });
            try {
                const resp = await this.$api({
                    url: `/Tool/GetStatementForm?SNO=${sno}`,
                    method: 'GET',
                });
                this.form = resp.data.item;
                console.log('Variable: ', resp.data.item);
            } finally {
                loading.close();
            }
        },

        fetchBankList() {
            this.$api({
                url: '/Tool/GetBankAccountOptions',
                method: 'GET',
            }).then((resp) => {
                this.bankAccountList = resp.data.options;
            });
        },

        getItemName(itemSno) {
            const hierarchy = [null, null, null];

            for (const t in statementTypes) {
                const options = this.$store.getters['statement/statementUiOptions'][statementTypes[t].key];
                for (const i in options) {
                    const lv1Item = options[i];
                    for (const j in lv1Item.childSettings) {
                        const lv2Item = lv1Item.childSettings[j];
                        if (lv2Item.sno === itemSno) {
                            hierarchy[0] = statementTypes[t].value;
                            hierarchy[1] = lv1Item.iteM_NAM;
                            hierarchy[2] = lv2Item.iteM_NAM;
                            break;
                        }
                    }
                }
            }

            return hierarchy.join(' / ');
        },
        getBankName(sno) {
            if (this.bankAccountList.length > 0 && sno) {
                const bank = this.bankAccountList.find((x) => x.sno === sno);
                if (bank) {
                    return bank.tpc;
                }
                return null;
            }
            return null;
        },
        getBankAcc(sno) {
            if (this.bankAccountList.length > 0 && sno) {
                const bank = this.bankAccountList.find((x) => x.sno === sno);
                if (bank) return bank.bnK_ACC;
                return null;
            }
            return null;
        },
        getUpdateStaffName() {
            if (this.form.upD_USR) {
                return this.form.upD_USR;
            }
            if (this.form.upD_DAT === this.form.crT_DAT) {
                return this.form.crT_USR;
            }
            return '';
        },

        refresh() {
            if (this.sno) this.fetchDetailData(this.sno);
            else this.emptyData();
        },

        onChangeFiles(value) {
            this.form.attachments = value;
        },
    },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.variable-statment-detail-dialog {
    .el-dialog {
        max-width: 700px !important;
    }
    .alert-block .el-alert__content {
        width: 100%;
    }
}
</style>
